// extracted by mini-css-extract-plugin
module.exports = {"color-button":"Editor_color-button__38JSn","color-block":"Editor_color-block__qZ-bL"};